var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dataProvider } from "../providers/dataProvider";
import { useState, useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
var MaintenanceNotification = function (_a) {
    var _b = _a.bgcolor, bgcolor = _b === void 0 ? "#ff9800" : _b, _c = _a.color, color = _c === void 0 ? "white" : _c, _d = _a.p, p = _d === void 0 ? 1 : _d, _e = _a.mt, mt = _e === void 0 ? 1 : _e, _f = _a.mb, mb = _f === void 0 ? -1 : _f, _g = _a.borderRadius, borderRadius = _g === void 0 ? 1 : _g, _h = _a.boxShadow, boxShadow = _h === void 0 ? 2 : _h, _j = _a.fontWeight, fontWeight = _j === void 0 ? 500 : _j, _k = _a.sx, sx = _k === void 0 ? {} : _k;
    var _l = useState(null), notification = _l[0], setNotification = _l[1];
    var _m = useState(true), loading = _m[0], setLoading = _m[1];
    useEffect(function () {
        var fetchNotification = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, dataProvider.getMaintanenceNotification()];
                    case 1:
                        response = _a.sent();
                        console.log("Maintenance notification response:", response.data);
                        setNotification(response.data);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Failed to fetch maintenance notification:", error_1);
                        setNotification(null);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchNotification();
    }, []);
    // Don't render anything if loading or no notification
    if (loading || !notification || notification.length === 0) {
        return null;
    }
    return (_jsx(Grid, { item: true, xs: 12, children: _jsx(Box, { bgcolor: bgcolor, color: color, p: p, mt: mt, mb: mb, borderRadius: borderRadius, display: "flex", alignItems: "center", justifyContent: "center", width: "auto", maxWidth: "fit-content", mx: "auto", boxShadow: boxShadow, sx: __assign({ transition: 'all 0.3s ease-in-out', '&:hover': {
                    boxShadow: boxShadow + 1,
                } }, sx), children: _jsxs("div", { children: [notification[0].message_en && _jsx(Typography, { variant: "body1", align: "center", style: { fontWeight: fontWeight }, children: notification[0].message_en }), notification[0].message_cn && _jsx(Typography, { variant: "body1", align: "center", style: { fontWeight: fontWeight }, children: notification[0].message_cn })] }) }) }));
};
export default MaintenanceNotification;
